const AuthRoutes = {
  signUp: "/auth/signup"
}

export default AuthRoutes;